import { getUtmString } from '$lib/utils/utmParams';
import { derived, writable } from 'svelte/store';
import { page } from '$app/stores';

// TODO: we should rename this since it is not (only) UTM specific anymore

const utmParams = writable('');

export function setUtmParams(params: Record<string, string | null>) {
	utmParams.set(getUtmString(params));
}

// these URLs should directly go to the order flow
const pdpUrls = ['/(marketing)/order-now', '/(marketing)/friend'];

// hack: we have to modify the header CTA from the /friends page
export const friendsCtaUrl = writable('');

export const reservationUrl = derived(
	[utmParams, page, friendsCtaUrl],
	([utm, { route }, friendsCta]): { url: string; label: string } => {
		const utmQuery = utm.length > 0 ? `?${utm}` : '';

		if (route.id === '/(marketing)/(referral)/friends') {
			return {
				url:
					friendsCta.length > 0
						? friendsCta.includes('?')
							? `${friendsCta}&${utmQuery.replace('?', '')}`
							: `${friendsCta}${utmQuery}`
						: `/order${utmQuery}`,
				label: 'Order now'
			};
		}

		if (route.id && pdpUrls.includes(route.id)) {
			return {
				url: '/order-now' + utmQuery,
				label: 'Order now'
			};
		}

		return {
			url: '/order-now' + utmQuery,
			label: 'Shop now'
		};
	}
);
